import { HttpContextToken } from "@angular/common/http";


export default class HttpContextTokens {
    public static readonly SKIP_ERROR_HANDLING = new HttpContextToken(() => false);
    public static readonly MAX_RETRY_OVERRIDE = new HttpContextToken(() => -1);
    public static readonly ERROR_REASON_PREFIX = new HttpContextToken(() => null);
}
